<template>
    <!-- 发布帖子 -->
    <el-dialog :title="$t('个人信息')" top="0" width="550px" :visible.sync="isVisible" @close="closeModal">

        <div class="avatar-box df jcc">
            <el-avatar :size="99" :src="userInfoList.user_avatar_att_url" @error="errorHandler">
                <img src="@/assets/images/avatar.png" alt="">
            </el-avatar>
        </div>
        <div class="name">
            {{ userInfoList.user_nick_name }}
        </div>

        <div class="dengji df jcc">
            <span class="box1 fn">{{ $t('当前等级') }}</span>
            <span class="box2 fn">Lv{{ userInfoList.user_points_level }}</span>
            <div class="imglist">

                <!-- <img :src="userInfoList.user_medal_front_icon_arr" alt=""> -->


                <template v-for="(item, index) in userInfoList.user_logo_arr">
                    <img :src="require('@/assets/images/grade/sign-' + item)" alt="" v-if="!currLanguage">
                    <img :src="require('@/assets/images/grade_en/sign-' + item)" alt="" v-else>

                </template>

                <template v-if="userInfoList.user_medal">
                    <img :src="require('@/assets/images/grade/level-' + userInfoList.user_medal + '.png')"
                        v-if="!currLanguage" alt="">
                    <img :src="require('@/assets/images/grade_en/level-' + userInfoList.user_medal + '.png')" v-else
                        alt="">
                </template>

            </div>
        </div>

        <!--  -->
        <div class="comment-box df jcc" style="margin-top: 36px;">
            <div class="li">
                <p class="t1">{{ $t('文章') }}</p>
                <span class="number">{{ userInfoList.user_topic_article_count }}</span>
            </div>
            <div class="li">
                <p class="t1">{{ $t('帖子') }}</p>
                <span class="number">{{ userInfoList.user_post_count }}</span>
            </div>
            <div class="li">
                <p class="t1">{{ $t('评论&回复') }}</p>
                <span class="number">{{ userInfoList.user_comment_count }}</span>
            </div>
            <div class="li">
                <p class="t1">{{ $t('提问') }}</p>
                <span class="number">{{ userInfoList.user_que_count }}</span>
            </div>
        </div>
        <div class="comment-box df jcc">
            <div class="li">
                <p class="t1">{{ $t('关注人数') }}</p>
                <span class="number">{{ userInfoList.user_follow_count }}</span>
            </div>
            <div class="li">
                <p class="t1">{{ $t('粉丝数') }}</p>
                <span class="number">{{ userInfoList.user_fans_count }}</span>
            </div>
        </div>


        <span slot="footer" class="dialog-footer df jcc">
            <el-button type="primary" class="btn2" @click="submitPost" :loading="publisherFollowLoading">
                <span class="iconfont mr-6">&#xe659;</span>{{ userInfoList.have_be_follow == 1 ? $t('已关注') : $t('关注') }}
            </el-button>
        </span>
    </el-dialog>
</template>
<!-- <try-editor v-model="formData.ttar_content" :height="500" -->
<script>
import { getuserDetail } from "@api/common";
export default {
    props: {
        id: {
            type: [String, Number], // 指定参数类型
            default: 0
            // required: true // 是否为必需参数
        },
        
        publisherFollowLoading: {
            type: [Boolean], // 指定参数类型
            default: false
            // required: true // 是否为必需参数
        }
    },
    data() {
        return {
            isVisible: false,

            userInfoList: {},

            currLanguage: 'cn',


        };
    },

    watch: {

        isVisible(newVal, oldVal) {
            if (newVal) {
                setTimeout(() => {
                    this.getData();
                }, 20);
            }

        }
    },
    mounted() {
        this.getData();
        let Language = localStorage.getItem('currentLanguage'); // 获取本地语言
        this.currLanguage = Language && Language !== 'zh';


    },
    methods: {

        errorHandler() {
            return true
        },
        async getData() {

            if (this.id) {

                let res = await getuserDetail({ id: this.id });

                this.userInfoList = res.data;
            }

        },
        openModal() {
            this.isVisible = true;
        },
        closeModal() {
            this.isVisible = false;
            this.postContent = ''; // 清空内容
        },
        submitPost() {

            this.$emit('post-submitted', this.id);

            setTimeout(() => {
                this.closeModal();
            }, 1000);

        }
    }
};
</script>

<style scoped lang="scss">
.imglist {
    img {
        max-height: 26px;
    }
}

.dengji {
    margin-top: 24px;

    .box1 {
        background-image: url("../assets/images/path-bg1.png");
        background-size: auto 100%;
        line-height: 21px;
        height: 22px;
        font-size: 12px;
        background-position: right center;
        background-repeat: no-repeat;
        color: #DD291E;
        padding-right: 16px;
        background-color: #FFE2E0;
        border-radius: 4px;
        padding-left: 8px;
        position: relative;

    }

    .box2 {
        background-image: url("../assets/images/path-bg2.png");
        background-size: auto 100%;
        line-height: 21px;
        height: 22px;
        font-size: 12px;
        background-position: left center;
        background-repeat: no-repeat;

        padding-left: 16px;

        border-radius: 4px;
        padding-right: 8px;
        overflow: hidden;
        position: relative;
        left: -5px;
        color: #41D56C;

        &::after {
            content: "";
            display: block;
            width: calc(100% - 10px);
            height: 22px;
            // border-radius: 10px 4px 4px 4px;
            background-color: #EFFAF2;
            position: absolute;
            right: 0;
            top: 0;
            z-index: -1;
        }

    }
}

::v-deep() {
    .el-dialog__headerbtn {
        display: none;
    }

    .el-dialog__header {
        padding: 30px 36px 0px;
    }

    .el-dialog {
        max-height: 82vh;
        border-radius: 12px;
        transform: translateY(-50%);
        top: 50%;
    }



    .el-dialog__body {
        margin-top: 34px;
        width: calc(100% - 24px);
        padding: 8px 12px 0 36px;
        max-height: calc(82vh - 162px);
        overflow: hidden;
        overflow-y: scroll;
        text-align: center;

        &::-webkit-scrollbar {
            width: 6px;
            height: 4px;
            background: transparent;
            border-radius: 8px;
        }

        &::-webkit-scrollbar-thumb {
            background: #CF4325;
            border-radius: 8px;
        }
    }

    .el-dialog__footer {
        padding: 26px 36px 40px;
    }

    .dialog-footer {


        .btn2 {
            min-width: 160px !important;
            height: 46px !important;
            border-radius: 30px !important;
            padding: 0 16px !important;
            font-size: 16px;

        }


        .btn2 {
            // background-color: #D64F31;
            background: linear-gradient(to right, #F7574D, #E13025);
            border: none;
            font-family: "MicrosoftYaHeiSemibold";

            .iconfont {
                font-size: 10px;
                position: relative;
                top: -2px;
            }
        }
    }


}

.avatar-box {
    // display: inline-block;
    position: relative;
    // padding-bottom: 10px;

    &::after {
        content: "";
        display: block;
        box-sizing: content-box;
        width: 105px;
        height: 105px;
        border-radius: 50%;
        border: 0.5px solid #EC8680;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }

    &::before {
        content: "";
        display: block;
        box-sizing: content-box;
        width: 113px;
        height: 113px;
        border-radius: 50%;
        border: 0.5px solid #FFCBCB;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
}

.name {
    font-size: 18px;
    margin-top: 22px;
}

.comment-box {
    margin-bottom: 4px;

    &:first-child {
        margin-top: 36px;
    }

    .li {
        width: 116px;
        text-align: center;

        .t1 {
            font-size: 14px;
            color: #9e8785;
            margin-bottom: 6px;
        }

        .number {
            font-size: 20px;
            font-weight: bold;
            color: #160504;
        }
    }
}
</style>